import React from "react";
import {
  Filter,
  Create,
  AutocompleteInput,
  SaveButton,
  List,
  FunctionField,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  EditButton,
  ReferenceInput,
  DateInput,
  DateField,
  DeleteButton
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";
import moment from "moment";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const HolidayTitle = object => (
  <span>
    {" Edit Loction entry "} {object.record.location_name}
  </span>
);

const HolidayCreateTitle = record => <span>Create Holiday entry</span>;

const HolidaysListFilter = props => (
  <Filter {...props}>
    <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
  </Filter>
);

const validateForm = values => {
  const errors = {};
  if (!values.location_id) {
    errors.location_id = ["Location is required"];
  }
  if (!values.date) {
    errors.date = ["Date is required"];
  }
  return errors;
};

export const HolidaysList = props => (
  <List
    {...props}
    title="Holidays"
    resource="holidays"
    pagination={<ListPagination />}
    filters={<HolidaysListFilter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Holiday ID" source="id" />
      <DateField label="Date" source="date" />
      <ReferenceField
        label="Location"
        source="location_id"
        reference="locations"
        linkType={false}
        allowEmpty={true}
      >
        <FunctionField
          render={location =>
            `${location.location_name} (${location.location3letter_name})`
          }
        />
      </ReferenceField>
      <EditButton />
    </Datagrid>
  </List>
);

const HolidaysToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/holidays`} />
    <Button
      component={Link}
      to={{
        pathname: `/holidays`
      }}
      label="Back to Holidays"
    >
      <ArrowBackIcon />
    </Button>
    <DeleteButton record={props.record} resource={props.resource} />
  </Toolbar>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const HolidaysEdit = props => (
  <Edit title={<HolidayTitle />} {...props}>
    <SimpleForm
      toolbar={<HolidaysToolbar props={{ ...props }} />}
      validate={validateForm}
    >
      <ReferenceInput
        label="Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <AutocompleteInput
          optionText={location =>
            `${location.location_name} (${location.location3letter_name})`
          }
        />
      </ReferenceInput>
      <DateInput label="Date" source="date"  locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
    </SimpleForm>
  </Edit>
);

export const HolidaysCreate = props => (
  <Create title={<HolidayCreateTitle />} {...props}>
    <SimpleForm validate={validateForm}>
      <ReferenceInput
        label="Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <AutocompleteInput
          optionText={location =>
            `${location.location_name} (${location.location3letter_name})`
          }
        />
      </ReferenceInput>
      <DateInput label="Date" source="date" locales="es-Es" options={{ timeZone: 'UTC' }} />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/holidays.js